<template>
    <div class="single tableStyle">

        <!-- 模式 -->
        <div class="single_wrap">
            <div class="left">
                <el-button type="primary" size="small" @click="handleAddMode">新增模式</el-button>
                <div class="mode_list">
                    <div class="mode_list_item" :class="{mode_active:indexMode === null}" @click="handleFilterMode({},null)">全部</div>
                    <div class="mode_list_item" :class="{mode_active:indexMode === index}" v-for="(item,index) in modeList" :key="index" @click="handleFilterMode(item,index)">
                        <div class="mode_list_item_left">{{item.name}}</div>
                        <div class="mode_list_item_right">
                            <i class="el-icon-edit" @click="handleEditMode(item)"></i>
                            <i class="el-icon-delete" @click="handleDeleteMode(item)"></i>
                        </div>                        
                    </div>
                    
                </div>
            </div>
            <div class="right">

                <el-row>
                    <el-col :span="24">
                        <el-button type="primary" size="small" @click="openDialog">新增配置</el-button>
                    </el-col>
                </el-row>

                <div class="tableArea">
                    <el-table :data="tableData" style="width: 100%" height="100%">
                        <el-table-column type="index" label="序号" align="center"></el-table-column>
                        <el-table-column prop="date" label="充电功率（W）" align="center">
                            <template slot-scope="scope">
                                {{scope.row.charge_power_start}} ~ {{scope.row.charge_power_end}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="gp" label="收费模式" align="center">
                            <template slot-scope="scope">
                                {{scope.row.gp.name}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="收费标准（元 / 分钟）" align="center"></el-table-column>
                        <el-table-column prop="remark" label="适用车型"></el-table-column>
                        <el-table-column label="操作" align="center" width="200">
                            <template slot-scope="scope">
                                <el-button type="primary" plain size="mini" @click="goEdit(scope.row)">修改</el-button>
                                <el-button type="danger" plain size="mini" @click="del(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="pageFoot flex">
                    <div class="tongji">统计：共{{total}}个</div>
                    <el-pagination
                        layout="total, prev, pager, next, sizes"
                        background
                        :page-size="queryForm.size"
                        :total="total"
                        :page-sizes="[20,50,100,200,500,1000]"
                        @size-change="sizeChange"
                        @current-change="changePage">
                    </el-pagination>
                </div>


            </div>            
        </div>

        <el-dialog
            :title="addForm.id ? '修改配置':'新建配置'"
            width="30%"
            custom-class="dialogRadius"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="dialogVisible"
            :before-close="closeDialog">
            <el-form :model="addForm" :rules="rules" ref="addForm" label-width="auto">
                <el-row>
                    <el-col :xs="13" :sm="13" :md="13" :lg="13" :xl="13">
                        <el-form-item label="充电功率" prop="charge_power_start">
                            <el-input v-model.number="addForm.charge_power_start" placeholder="例：0" min="0" onkeyup="this.value=this.value.replace(/[^\0-9]/g, '')">
                                <template slot="append">W</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                        <el-form-item label-width="0" style="text-align: center">
                        至
                        </el-form-item>
                    </el-col>
                    <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="9">
                        <el-form-item prop="charge_power_end" label-width="0">
                            <el-input v-model.number="addForm.charge_power_end" placeholder="例：150" onkeyup="this.value=this.value.replace(/[^\0-9]/g, '')" >
                                <template slot="append">W</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="收费模式：" prop="gp_id">
                    <el-select v-model="addForm.gp_id" placeholder="请选择">
                        <el-option v-for="(item,index) in modeList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="收费标准：" prop="price">
                    <el-input v-model="addForm.price" placeholder="请输入收费标准" type="number">
                        <template slot="append">元 / 分钟</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="适用车型：" prop="remark">
                    <el-input v-model="addForm.remark" placeholder="例：国标电动两轮自行车" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>


        <!-- 模式弹窗 -->
        <el-dialog  :title="formMode.id?'编辑':'新增'+'模式'" :visible.sync="dialogVisibleMode" width="30%" @close="handleCloseMode">
            <el-form ref="formMode" :model="formMode" label-width="auto">
                <el-form-item label="模式名称：" prop="name" :rules="{required:true,message:'请输入收费模式名称',trigger: 'blur'}">
                    <el-input v-model="formMode.name" placeholder="请输入收费模式名称"></el-input>
                </el-form-item>
            </el-form>            
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleMode = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmitMode('formMode')">确 定</el-button>
            </span>
        </el-dialog>





    </div>
</template>
<script>
export default {
    data() {
        return {
            queryForm: {
                page: 1,
                size: 20,

                gp_name:'', //收费模式name
                gp_id: null, //收费模式id
            },
            total: 0,
            tableData: [],

            dialogVisible: false,
            addForm: {
                charge_power_start: '',
                charge_power_end: '',
                price: '',
                remark: '',

                gp_id: null, //收费模式
            },
            rules: {
                charge_power_start: [{required: true, message: '请输入充电功率范围', trigger: 'blur'}],
                charge_power_end: [{required: true, message: '请输入充电功率范围', trigger: 'blur'}],
                price: [{required: true, message: '请输入收费标准', trigger: 'blur'}],
                remark: [{required: true, message: '请输入适用车型', trigger: 'blur'}],
                gp_id:[{required: true, message: '请选择收费模式', trigger: 'change'}],
            },


            dialogVisibleMode:false, //模式弹窗

            //收费模式
            listQuery:{
                page:1,
                size:100
            },
            formMode:{
                id:'',
                name:'',
            },
            modeList:[],
            indexMode: null, //点击的模式索引
        }
    },
    created() {
        this.getTableList();

        this.getModeList(); //收费模式
    },


    methods: {
        getTableList(){
            this.$http.get(this.common.admin + '/admin/chargePriceList', {
                params: this.queryForm
            }).then(res => {
                if(res.code === 200){
                    this.tableData = res.data.list;
                    this.total = res.data.total;
                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        openDialog(){
            this.dialogVisible = true;
        },
        closeDialog(){
            this.dialogVisible = false;
            this.addForm = {
                charge_power_start: '',
                charge_power_end: '',
                price: '',
                gp_id: null,
            };
            this.$refs.addForm.clearValidate();
        },
        submit(){
            this.$refs.addForm.validate(v => {
                if(v === true){
                    let obj = Object.assign({}, this.addForm),
                        url = this.addForm.id ? '/admin/chargePriceEdit' : '/admin/chargePriceAdd';
                    this.$http.post(this.common.admin + url, obj).then(res => {
                        if(res.code === 200){
                            this.$message.success(this.addForm.id ? '编辑成功':'新增成功');
                            this.queryForm.page = 1;
                            this.getTableList();
                            this.closeDialog();
                        }else{
                            return this.$message.error(res.msg);
                        }
                    });
                }
            });
        },
        goEdit(data){
            this.$http.get(this.common.admin + '/admin/chargePriceDetail', {
                params: {id: data.id}
            }).then(res => {
                if(res.code === 200){
                    this.addForm = res.data;
                    this.openDialog();
                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        del(data){
            this.$confirm('是否确定删除此配置？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get(this.common.admin + '/admin/chargePriceDelete',{
                    params: {id: data.id}
                }).then(res => {
                    if(res.code === 200){
                        this.getTableList();
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }else{
                        return this.$message.error(res.msg);
                    }
                });
                
            }).catch(() => {});
        },
        sizeChange(val){
            this.queryForm.size = val;
            this.getTableList();
        },
        changePage(val){
            this.queryForm.page = val;
            this.getTableList();
        },

        //收费模式列表
        getModeList(){
            this.$api.getChargePriceGroup(this.listQuery).then(res=>{
                if(res.code === 200){
                    this.modeList = res.data.list;
                }
            })
        },
        
        //点击左侧模式过滤右侧相应列表
        handleFilterMode(item,index){
            this.indexMode = index;
            this.queryForm.gp_id = item.id;
            this.getTableList();
        },

        //模式新增
        handleAddMode(){
            this.dialogVisibleMode = true;
        },

        handleEditMode(item){
            this.dialogVisibleMode = true;            
            this.formMode.id = item.id;
            this.formMode.name = item.name;

        },

        handleDeleteMode(item){
            this.$confirm(`确定删除模式：${item.name}?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.delChargePriceGroup({id:item.id}).then(res=>{
                    if(res.code === 200){
                        this.$message.success('删除成功');
                        this.getModeList();
                    }
                });
            }).catch(() => {
                // this.$message.info('已取消删除');      
            });
        },


        //模式提交
        handleSubmitMode(formName){
            this.$refs[formName].validate(valid=>{
                if(valid){
                    let url = this.formMode.id?'editChargePriceGroup':'addChargePriceGroup';
                    let text = this.formMode.id?'修改':'新增' + '成功';
                    this.$api[url](this.formMode).then(res=>{
                        if(res.code === 200){
                            this.$message.success(text);
                            this.dialogVisibleMode = false;
                            this.getModeList();
                        }
                    })
                }
            })

        },

        //关闭模式弹窗
        handleCloseMode(){
            this.$refs.formMode.resetFields();
        }


        
        





    },
}
</script>
<style lang="less" scoped>
    .single{
        
        .single_wrap{
            display: flex; 
            .left{height:100%;width: 300px;border-right:1px solid #ddd;margin-right:20px;
                // padding:0 20px;
                .mode_list{margin-top:30px;}
                .mode_list_item{display: flex;justify-content: space-between;font-size: 14px;padding:5px 20px;
                &.mode_active{background: #ddd;}
                }
                .mode_list_item_right i:nth-child(1){margin-right: 10px;}
                .mode_list_item_right i{cursor: pointer;}
            }
            .right{flex: 1;}
        }

        .tableArea{
            height:calc(100vh - 200px);
            
        }



        .pageFoot{
            align-items: center;
            justify-content: space-between;

            .tongji{
                font-size: 14px;
            }
        }
    }
</style>